import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {AssetsService} from '../../../services/assets.service';
import {MapIconsService} from '../../../services/map-icons.service';
import {MapAssetWithIcon} from '../../../model/custom/map/map-asset-with-icon';
import {MapAsset} from '../../../model/custom/map/map-asset';

@Component({
  selector: 'app-map-cluster-details',
  templateUrl: './map-cluster-details.component.html',
  styleUrls: ['./map-cluster-details.component.scss']
})
export class MapClusterDetailsComponent {

  @Input() public hashedMapAsset: Map<string, MapAsset>;
  @Output() public onAssetSelected: EventEmitter<string> = new EventEmitter<string>();

  public assetWithIconList: MapAssetWithIcon[] = [];
  public aliasFilter: string = '';

  public loading: boolean;
  public numberOfAssets: number;

  constructor(private assetsService: AssetsService,
              public mapIconsService: MapIconsService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  @Input()
  set assetUuids(assetUuids: string[]) {
    this.numberOfAssets = assetUuids.length;
    this.loading = true;
    this.assetsService.getAssetSummariesWithIconByUuids(assetUuids).subscribe({
      next: (response): void => {
        const array = [];
        response.assets.forEach((asset: MapAssetWithIcon) => {
          array.push(new MapAssetWithIcon(asset.alias, asset.description, asset.uuid, asset.icon, asset.status, asset.representationId));
        });
        this.assetWithIconList = array;
        this.changeDetectorRef.detectChanges();
      },
      error: undefined,
      complete: (): void => {
        this.loading = false;
      }
    });
  }

  get filteredAssetsWithIcon(): MapAssetWithIcon[] {
    return this.assetWithIconList.filter(asset => asset.alias.includes(this.aliasFilter));
  }

}
